var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.318,
    height: 55.318,
    viewBox: "0 0 55.318 55.318",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_9",
    "data-name": "Subtraction 9",
    d: "M27.66,55.318A27.666,27.666,0,0,1,16.893,2.174,27.666,27.666,0,0,1,38.425,53.144,27.484,27.484,0,0,1,27.66,55.318Zm3.027-23.275a1.486,1.486,0,0,0,0,2.972h4.458a7.431,7.431,0,0,0,0-14.861H30.686a1.486,1.486,0,0,0,0,2.972h4.458a4.458,4.458,0,0,1,0,8.916Zm-10.4-11.889a7.431,7.431,0,0,0,0,14.861h4.458a1.486,1.486,0,1,0,0-2.972H20.283a4.458,4.458,0,0,1,0-8.916h4.458a1.486,1.486,0,1,0,0-2.972ZM23.256,26.1a1.486,1.486,0,1,0,0,2.971h8.916a1.486,1.486,0,1,0,0-2.971Z",
    fill: "#fcbf49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyShareIcon);
export default __webpack_public_path__ + "static/media/copy-share-icon.493351e57baaa2ffb8c9ada675154790.svg";
export { ForwardRef as ReactComponent };